import { render, staticRenderFns } from "./articlesModal.vue?vue&type=template&id=6de20ffb"
import script from "./articlesModal.vue?vue&type=script&lang=js"
export * from "./articlesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports